import { ReactComponent as WarningIcon } from '@/assets/icons/alert-exclamtion.svg';
import { ReactComponent as ChartIcon } from '@/assets/icons/chart-icon.svg';
import { ReactComponent as DocumentWarningIcon } from '@/assets/icons/document-warning.svg';
import { ReactComponent as FilesIcon } from '@/assets/icons/files-records.svg';
import { ReactComponent as GavelIcon } from '@/assets/icons/gavel-icon.svg';
import { ReactComponent as LateDeliveryIcon } from '@/assets/icons/late-delivery.svg';
import { ReactComponent as OpenboxIcon } from '@/assets/icons/open-box.svg';
import { ReactComponent as TrackingFailedIcon } from '@/assets/icons/tracking-failed.svg';
import { QUOTE_STATUSES } from '../QuoteCard/constants';

export type QuoteFooterStatusKey =
  | 'TotalRecords'
  | 'Rating Result'
  | 'Spot Bid'
  | (typeof QUOTE_STATUSES)[keyof typeof QUOTE_STATUSES];

export const quoteStatusIconConfig: Partial<
  Record<QuoteFooterStatusKey, { Icon: React.FC<React.SVGProps<SVGSVGElement>>; translationKey: string; order: number }>
> = {
  TotalRecords: {
    Icon: FilesIcon,
    translationKey: 'searchQuote.footer.totalRecords',
    order: 1,
  },
  [QUOTE_STATUSES.internalReview]: {
    Icon: DocumentWarningIcon,
    translationKey: 'searchQuote.footer.internalReview',
    order: 2,
  },
  [QUOTE_STATUSES.openForBid]: {
    Icon: OpenboxIcon,
    translationKey: 'searchQuote.footer.openForBid',
    order: 3,
  },
  [QUOTE_STATUSES.readyForAward]: {
    Icon: TrackingFailedIcon,
    translationKey: 'searchQuote.footer.readyForAward',
    order: 4,
  },
  [QUOTE_STATUSES.awarded]: {
    Icon: LateDeliveryIcon,
    translationKey: 'searchQuote.footer.awarded',
    order: 5,
  },
  [QUOTE_STATUSES.cancelled]: {
    Icon: WarningIcon,
    translationKey: 'searchQuote.footer.cancelled',
    order: 6,
  },
  'Rating Result': {
    Icon: ChartIcon,
    translationKey: 'searchQuote.footer.ratingResult',
    order: 7,
  },
  'Spot Bid': {
    Icon: GavelIcon,
    translationKey: 'searchQuote.footer.spotBid',
    order: 8,
  },
};
